export const MAX_UPLOAD_FILE_SIZE = 20_000_000; // 20Mo
export const LINK_TO_COMPRESS_FILE =
  'https://support.apple.com/en-gb/guide/preview/prvw1509/mac';
